module.exports = __webpack_public_path__ + "static/img/icon_top@2x.d3fc312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/KtbTrio_min/icon_top@2x.png
// module id = mmJA
// module chunks = 69